import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { organizationApi } from '@/features/recruiter/api/organization.api'

const QUERY_KEY = ['recruiter', 'organization'] as const

export function useOrganizationQuery() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: organizationApi.get })
}

export function useUpdateOrganization() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: organizationApi.update,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}

export function useUploadOrgLogo() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: organizationApi.uploadLogo,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}
